import React, { Component } from 'react';
//import DetailOfRequest from '../DetailOfRequest';
import { HandleSubmit } from '../../func/HandleSubmit';
import cookie from "../../func/Cookie";
import matchSorter from 'match-sorter'
import ReactTable from 'react-table-6'
import "react-table-6/react-table.css";
import ProgressDetailView from "./ProgressDetailView";
import ProgressDetailEdit from "./ProgressDetailEdit"

class ProgressList extends Component {
    myRef = [];
    constructor(props) {
        super(props);
        this.state = {
            Submit: '',
            // show_view_row: [],
            // show_rem_row: [],
            Action: this.props.action,
            ActionExpander: '',
            // RestForm: false,
            SendParameters: { request_code: this.props.request_code },
            TableOfProgress: [],
        };
        this.DeleteRequest = this.DeleteRequest.bind(this);
        this.YesFunc = this.YesFunc.bind(this);
        this.NoFunc = this.NoFunc.bind(this);
        this.ReloadAgain = this.props.reloadagain.bind(this);
    }
    async initComponent() {
        this.setState({
            Loading: true,
        });
        await this.GetListOfRow();
        this.setState({
            Loading: false,
        });
    }
    async GetListOfRow() {
        let response_info = await HandleSubmit('getdata/getlistofprogressofrequestforreport', this.state.SendParameters);
        this.setState({
            TableOfProgress: response_info,
        });
    }
    async componentDidMount() {
        this.initComponent();
    }
    // async componentWillReceiveProps() {
    //     this.initComponent();
    // }
    NoFunc(index) {
        this.setState({
            show_rem_row: this.state.show_rem_row
        });
    }
    async YesFunc(ReqNum) {
        this.DeleteRequest(ReqNum);
        this.ReloadAgain();
    }
    async DeleteRequest(req_code) {
        const sendparameter = {
            object: "request",
            detail: { request_code: req_code }
        }
        var response_info = await HandleSubmit('delete/index', sendparameter);
    }
    render() {
        //console.log(this.state.SendParameters.detail);
        if (this.state.Loading) { return "در حال بارگزاری..."; }
        let ActionExpander = '';
        return (
            <div style={{ "textAlign": "center", "border": "4px solid rgba(0, 150, 255, 0.91)" }}>
                <div> شماره سفارش {this.props.request_code}</div>
                <ReactTable
                    className="-striped -highlight"
                    showPagination={false}
                    minRows={0}
                    headerStyle={{ fontWeight: "bold", fontcolor: "red" }}
                    data={this.state.TableOfProgress}
                    SubComponent={(row) => {
                        switch (ActionExpander) {
                            case "view":
                                return (<ProgressDetailView action={ActionExpander} request_code={row.original.request_code}
                                    progress={row.original.status_num} />
                                );
                            case "edit":
                                return (<ProgressDetailEdit action={ActionExpander} request_code={row.original.request_code}
                                    progress={row.original.status_num} />
                                );
                            case "remove":
                                return (
                                    <RemRow ReqNum={row.original.request_code} no={() => this.NoFunc(row.original.request_code)} yes={() => this.YesFunc(row.original.request_code)} />
                                );
                        }
                    }
                    }
                    columns={[
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    <div>{!isExpanded ? <span><button className="btn btn-outline-warning" onClick={() => ActionExpander = "view"}>+</button></span> : <span><button className="btn btn-outline-warning">-</button></span>}</div>
                                )
                            },
                        },
                        {
                            Header: "#",
                            accessor: "row",
                            maxWidth: 100,
                            minWidth: 20,
                            Cell: row => (row.value + 1)
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>  کاربر </div>,
                            accessor: "user_name",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>تاریخ </div>,
                            accessor: "date",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>وضعیت </div>,
                            accessor: "status_name",
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>وضعیت </div>,
                            accessor: "status_num",
                            show: false,
                        },
                        {
                            Header: () => <div style={{ fontWeight: "bold" }}>توضیحات </div>,
                            accessor: "desc",
                        },
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    (this.state.TableOfProgress.length - 1) == rest.index ? <div>{!isExpanded ? <span><button className="btn btn-outline-danger" onClick={() => ActionExpander = "edit"}>ویرایش</button></span> : <span><button className="btn btn-outline-danger">-</button></span>}</div> : null
                                );
                            },
                        },
                        {
                            expander: true,
                            width: 100,
                            Expander: ({ isExpanded, ...rest }) => {
                                return (
                                    (this.state.TableOfProgress.length - 1) == rest.index ? <div>{!isExpanded ? <span><button className="btn btn-outline-danger" onClick={() => ActionExpander = "remove"}>حذف</button></span> : <span><button className="btn btn-outline-danger">-</button></span>}</div> : null
                                );
                            },
                        },
                    ]}
                    className="-striped -highlight"
                />
            </div >
        );
    }
}
class RemRow extends Component {
    styles = {
        table: {
            textAlign: 'right',
            borderTop: "0px solid black",
            padding: "3px 20px"
        }
    }
    constructor(props) {
        super(props);
    }
    render() {
        if (this.props.Loading) { return "در حال بارگزاری..."; }
        return (
            <React.Fragment>
                <tr><td style={this.styles.table} colSpan="7" >آیا مایل به حذف درخواست {this.props.ReqNum} هستید؟</td></tr>
                <tr><td style={this.styles.table} colSpan="7"><button className="btn btn-danger" style={{ 'marginLeft': '10px' }} onClick={this.props.yes}>بله</button><button className="btn btn-danger" onClick={this.props.no}>خیر</button></td></tr>
            </React.Fragment>
        )
    }
}
export default (ProgressList);


// WEBPACK FOOTER //
// ./src/pages/Progress/ProgressList.js